// TODO this should be a type which we get from the backend
// this needs to be kept in sync with the related field in the backend Quote model
export const QuoteStatus = {
  Incomplete: 'INCOMPLETE',
  Complete: 'COMPLETE',
  RenewalEmailSent: 'RENEWAL_EMAIL_SENT',
  RenewalLinkGenerated: 'RENEWAL_LINK_GENERATED',
  RenewalInProgress: 'RENEWAL_IN_PROGRESS',
  Renewed: 'RENEWED',
  Submitted: 'SUBMITTED',
  InsurerResponse: 'INSURER_RESPONSE',
  IncompleteRenewal: 'INCOMPLETE_RENEWAL',
  ConfirmationInProgress: 'CONFIRMATION_IN_PROGRESS',
  IncompleteConfirmation: 'INCOMPLETE_CONFIRMATION',
  Confirmed: 'CONFIRMED',
  ContactInfoOnly: 'CONTACT_INFO_ONLY',
  InProgress: 'IN_PROGRESS',
} as const;

export type QuoteStatus = typeof QuoteStatus[keyof typeof QuoteStatus];

export const quoteStatuses = Object.values(QuoteStatus) as Array<QuoteStatus>;
